<div class="cd-page">
  <!-- SIDEBAR -->
  <app-counselor-nav></app-counselor-nav>

  <!-- MAIN -->
  <main class="cd-main" aria-label="Counselor dashboard">
    <div class="cd-header">
      <div>
        <h1 class="cd-title">Dashboard</h1>
        <p class="cd-subtitle">{{ today }} · {{ attentionCount() }} students need attention</p>
      </div>

      <button
        *hasPermission="permissions.REPORTS.CREATE"
        mat-flat-button
        (click)="createReportDialog()"
        data-testid="issue-reports-create"
      >
        Create Report
      </button>
    </div>

    <div class="cd-stats" role="list" aria-label="Dashboard statistics">
      <div class="cd-stat" role="listitem" [attr.aria-label]="totalStudents() + ' total students'">
        <div class="cd-stat-num" aria-hidden="true">{{ totalStudents() }}</div>
        <div class="cd-stat-label" aria-hidden="true">Total students</div>
      </div>
      <div
        class="cd-stat"
        role="listitem"
        [attr.aria-label]="avgCompletion() + '% average profile completion'"
      >
        <div class="cd-stat-num" aria-hidden="true">{{ avgCompletion() }}%</div>
        <div class="cd-stat-label" aria-hidden="true">Avg. profile completion</div>
      </div>
      <div
        class="cd-stat warn"
        role="listitem"
        [attr.aria-label]="attentionCount() + ' students need attention'"
      >
        <div class="cd-stat-num" aria-hidden="true">{{ attentionCount() }}</div>
        <div class="cd-stat-label" aria-hidden="true">Need attention</div>
      </div>
    </div>

    <div class="cd-cols">
      <!-- Student Roster -->
      <div class="cd-card">
        <div class="cd-card-header">
          <h2>Student roster</h2>
          <button class="cd-link" [attr.aria-label]="'View all ' + totalStudents() + ' students'">
            View all {{ totalStudents() }} →
          </button>
        </div>

        <div role="list" aria-label="Student roster">
          @for (s of students(); track s.id) {
            <div
              class="cd-student-row"
              role="listitem"
              [attr.aria-label]="
                (s.user.preferred_name || s.user.first_name) +
                ' ' +
                s.user.last_name +
                ', ' +
                gradeLabel(s.grade_level) +
                (s.Profile?.Career?.name ? ', ' + s.Profile!.Career!.name : '') +
                ', status: ' +
                statusLabel(s)
              "
            >
              <div class="cd-student-avatar" aria-hidden="true" [style.background]="avatarColor(s)">
                <app-user-avatar
                  [imageUrl]="s.Profile?.profile_picture_path"
                  [name]="s.user.first_name + ' ' + s.user.last_name"
                  [color]="avatarColor(s)"
                />
              </div>
              <div>
                <div class="cd-student-name">
                  {{ s.user.preferred_name || s.user.first_name }} {{ s.user.last_name }}
                </div>
                <div class="cd-student-meta">
                  {{ gradeLabel(s.grade_level) }}
                  @if (s.Profile?.Career?.name) {
                    · {{ s.Profile!.Career!.name }}
                  }
                </div>
              </div>
              <span class="cd-badge {{ deriveStatus(s) }}" aria-hidden="true">{{
                statusLabel(s)
              }}</span>
            </div>
          }
        </div>

        <button class="cd-card-footer" aria-label="View all students">View all students →</button>
      </div>

      <div class="cd-right">
        <!-- Deadlines -->
        <div class="cd-card">
          <div class="cd-card-header">
            <h2>Deadlines</h2>
            <button class="cd-link" (click)="addDeadline()" aria-label="Add new deadline">
              Add new
            </button>
          </div>

          <div role="list" aria-label="Upcoming deadlines">
            @for (d of deadlines; track d.title) {
              <div
                class="cd-deadline-item"
                role="listitem"
                [attr.aria-label]="d.title + ' — ' + d.date + (d.urgency ? ', ' + d.urgency : '')"
              >
                <div class="cd-deadline-dot {{ d.urgency }}" aria-hidden="true"></div>
                <div>
                  <div class="cd-deadline-title">{{ d.title }}</div>
                  <div class="cd-deadline-date">{{ d.date }}</div>
                </div>
              </div>
            }
          </div>

          <button class="cd-card-footer" aria-label="View full calendar">
            View full calendar →
          </button>
        </div>
      </div>
    </div>
  </main>
</div>
